import { fallbackLng } from "@/app/i18n/settings";
import { getCookies } from "@/utils/common/cookiesHelper/CookiesUtills";
import { CookiesItemEnum } from "@/utils/enums/CookiesItemEnum";

const usePath = () => {
  const lang =
    getCookies(CookiesItemEnum.COOKIE_I18N_NEXT_LANG_NAME) || fallbackLng;

  const dynamicImportJsonPath = async (endpoint: string) => {
    try {
      return await import(`@/public/api/${lang}/${endpoint}.json`).then(
        (m) => m.default,
      );
    } catch (error) {
      // console.error("error", error);
      return null;
    }
  };

  return {
    dynamicImportJsonPath,
  };
};

export default usePath;
